import Notification from '../../components/Notification/Notification';
import responseCodes from '../../constants/responseCodes';
import i18n from '../../i18n';
import * as linkedInImportService from '../../services/linkedInImportService';
import globalActionConstants from '../constants/globalActionConstants';
import linkedInActionConstants from '../constants/linkedInActionConstants';

const t = (key) => i18n.t(key, { ns: 'common' });

export const sendLinkedInImportEmail = (time) => async (dispatch) => {
  dispatch({ type: linkedInActionConstants.SET_LINKEDIN_IMPORT_START_TIME, payload: time });

  try {
    const response = await linkedInImportService.sendLinkedInImportEmail();
    if (response.data.response_code !== responseCodes.OK) {
      Notification.error(response.data.error);
    }
  } catch (error) {
    Notification.error(error.message);
  }
};

export const unsetLinkedInImportTime = () => async (dispatch) => {
  dispatch({ type: linkedInActionConstants.UNSET_LINKEDIN_IMPORT_START_TIME });
};

export const resetLinkedInLoader = () => ({
  type: linkedInActionConstants.SET_LOADER_OFF,
});

export const importLinkedInContacts = (data, navigateOnSuccess) => async (dispatch) => {
  dispatch({ type: globalActionConstants.SET_LOADING_ON });

  try {
    const response = await linkedInImportService.linkedInImport(data);
    if (response.data.response_code === responseCodes.OK) {
      dispatch({ type: linkedInActionConstants.IMPORT_LINKEDIN_CONTACTS_SUCCESS });
      dispatch({ type: globalActionConstants.SET_LOADING_OFF });
      navigateOnSuccess();
      Notification.success(response.data.message);
    } else {
      dispatch({ type: globalActionConstants.SET_LOADING_OFF });
      Notification.error(response.data.error?.message || response.data.error);
    }
  } catch (error) {
    dispatch({ type: globalActionConstants.SET_LOADING_OFF });
    Notification.error(error.message);
  }
};

export function getLinkedinData(url, successCb, errorCb) {
  return (dispatch) => {
    dispatch({ type: linkedInActionConstants.SET_LOADER_ON });

    linkedInImportService
      .getLinkedinData(url)
      .then((response) => {
        if (response.data.response_code === responseCodes.OK) {
          successCb(response.data.payload);
        } else {
          const errorMessage =
            response.data.payload?.error_message || response.data.error || t('notifications.unableToFetchLinkedIn');
          Notification.error(errorMessage);
          if (errorCb) errorCb(errorMessage);
        }
      })
      .catch((error) => {
        const errorMessage = error.response?.data?.payload?.error_message || t('notifications.somethingWentWrong');
        Notification.error(errorMessage);
        if (errorCb) errorCb(errorMessage);
      })
      .finally(() => {
        dispatch({ type: linkedInActionConstants.SET_LOADER_OFF });
      });
  };
}
